import moment from "moment";
import {Button} from "antd";
import {Link} from "react-router-dom";

import styles from "./earning.module.scss";

export const renderPayDetails = (showDetails, updateStatus) => {
    return (_, record) => {
        return (
            <div className={styles.actions}>
                <span className="user-link" onClick={() => showDetails(record.id, "Pay")}>View</span>
                <Button onClick={()=> updateStatus(record.id, "paid")} type="default"  style={{borderRadius: "4px", cursor: "pointer", color: "#52c41a", borderColor: "#52c41a"}}>
                    Paid
                </Button>
                <Button onClick={()=> updateStatus(record.id, "cancel")} type="default" danger style={{borderRadius: "4px", cursor: "pointer"}}>
                    Cancel
                </Button>
            </div>
        )
    }
}

export const cancelColumns = [
    {
        title: 'User',
        dataIndex: 'user',
        key: "user",
        width: '25%',
        render: (user) => <div>{`${user.first_name} ${user.last_name}`}</div>,
    },
    {
        title: 'Amount',
        dataIndex: 'price',
        key: "price",
        width: '25%',
        render: (price) => <div>{`${price} USD`}</div>,
    },
    {
        title: 'Date and time',
        dataIndex: 'date',
        key: "date",
        width: '25%',
        responsive: ['lg'],
        render: (_, record) => `${moment(record.date).format('MMMM Do YYYY')}`,
    },
    {
        title: 'Action',
        dataIndex: 'details',
        key: "details",
        width: '25%',
    },
];

export const paidColumns = [
    {
        title: 'User',
        dataIndex: 'user',
        key: "user",
        width: '25%',
        render: (user) => <div>{`${user.first_name} ${user.last_name}`}</div>,
    },
    {
        title: 'Amount',
        dataIndex: 'price',
        key: "price",
        width: '25%',
        render: (price) => <div>{`${price} USD`}</div>,
    },
    {
        title: 'Date and time',
        dataIndex: 'date',
        key: "date",
        width: '25%',
        responsive: ['lg'],
        render: (_, record) => `${moment(record.date).format('MMMM Do YYYY')}`,
    },
    {
        title: 'Action',
        dataIndex: 'details',
        key: "details",
        width: '25%',
    },
];

export const payColumns = [
    {
        title: 'User',
        dataIndex: 'user',
        key: "user",
        width: '25%',
        render: (user) => <div>{`${user.first_name} ${user.last_name}`}</div>,
    },
    {
        title: 'Amount',
        dataIndex: 'price',
        key: "price",
        width: '25%',
        render: (price) => <div>{`${price} USD`}</div>,
    },
    {
        title: 'Date and time',
        dataIndex: 'date',
        key: "date",
        width: '25%',
        responsive: ['lg'],
        render: (_, record) => `${moment(record.date).format('MMMM Do YYYY')}`,
    },
    {
        title: 'Action',
        dataIndex: 'details',
        key: "details",
        width: '25%',
    },
];

export const outstandingColumns = [
    {
        title: 'Mission', dataIndex: 'mission', key: 'mission', width: 220,
        render: (mission, record) => <Link to={`/missions/${record.mid}`}>{`#${record.mid} — ${mission?.mission_title || 'Untitled mission'}`}</Link>,
    },
    {
        title: 'Customer', dataIndex: 'client', key: 'client', width: 180,
        render: (client) => <div>{`${client?.first_name || ''} ${client?.last_name || ''}`.trim() || client?.email || 'Unknown'}</div>,
    },
    {
        title: 'Delegate', dataIndex: 'delegate', key: 'delegate', width: 180,
        render: (delegate) => <div>{`${delegate?.first_name || ''} ${delegate?.last_name || ''}`.trim() || delegate?.email || 'Unassigned'}</div>,
    },
    {
        title: 'Amounts', dataIndex: 'outstanding_amount', key: 'outstanding_amount', width: 190,
        render: (amount, record) => {
            const currency = (record.currency || 'USD').toUpperCase();
            return <div>
                <div>Due: {Number(record.amount_due || 0).toFixed(2)} {currency}</div>
                <div>Paid: {Number(record.amount_paid || 0).toFixed(2)} {currency}</div>
                <strong>Outstanding: {Number(amount || 0).toFixed(2)} {currency}</strong>
            </div>
        },
    },
    {
        title: 'Payment state', dataIndex: 'state', key: 'state', width: 190,
        render: (state, record) => <div>
            <div>{String(state || 'unknown').replaceAll('_', ' ')}</div>
            {record.last_failure_code && <small>Reason: {record.last_failure_code}</small>}
        </div>,
    },
    {title: 'Failures', dataIndex: 'failure_count', key: 'failure_count', width: 90},
    {
        title: 'Last attempt', dataIndex: 'last_attempt_at', key: 'last_attempt_at', width: 180,
        render: (value) => value ? moment(value).format('MMMM Do YYYY, HH:mm') : '—',
    },
];
